import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import image from "../assets/sre_foundation.jpeg"
import RatingStars from "../components/common/RatingStars";
import { BiInfoCircle } from "react-icons/bi";
import { HiOutlineGlobeAlt } from "react-icons/hi";
import CourseDetailsCard from "../components/core/Course/CourseDetailsCard";
import ReactMarkdown from "react-markdown";
import { BsFillCaretRightFill, BsFillCaretRightSquareFill } from "react-icons/bs";
import CourseAccordionBar from "../components/core/Course/CourseAccordionBar"
import Footer from "../components/common/Footer";

const CourseDetails = () => {
    const [isActive, setIsActive] = useState(Array(0));
    const handleActive = () => {
      // console.log("called", id)
      setIsActive(
        
      );
    };
  
    return (
      <>
        <div className={`relative w-full bg-richblue-5`}>
          <div className="mx-auto box-content px-4 lg:w-[1260px] 2xl:relative ">
            <div className="mx-auto grid min-h-[450px] max-w-maxContentTab justify-items-center py-8 lg:mx-0 lg:justify-items-start lg:py-0 xl:max-w-[810px]">
              <div className="relative block max-h-[30rem] lg:hidden">
                <div className="absolute bottom-0 left-0 h-full w-full shadow-[#161D29_0px_-64px_36px_-28px_inset]"></div>
                <img
                  src={image}
                  alt="course thumbnail"
                  className="aspect-auto w-full"
                />
              </div>

              <div
                className={`z-30 my-5 flex flex-col justify-center gap-4 py-5 text-lg text-richblack-5`}
              >
                <div>
                  <p className="text-4xl font-bold text-richblack-5 sm:text-[42px]">
                    Site Reliability Engineering (SRE) Foundation Training and
                    Certification
                  </p>
                </div>

                <p className={`text-richblack-200`}>
                  Recognized as one of the fastest-growing job roles, the SRE
                  profile empowers organizations to build resilient systems
                  while fostering innovation. The SRE Foundation course is
                  carefully designed to provide a robust understanding of SRE
                  principles, tools, and practices that ensure a balanced focus
                  on system stability and feature development.
                </p>
                <div className="text-md flex flex-wrap items-center gap-2">
                  <span className="text-yellow-25">5</span>
                  <RatingStars Review_Count={5} Star_Size={20} />
                  <span>{`(${5} reviews)`}</span>
                  <span> | </span>
                  <span>{`${200}+ Professionals Enrolled`}</span>
                </div>
                
                <div className="flex flex-wrap gap-5 text-lg">
                  <p className="flex items-center gap-2">
                    {" "}
                    <BiInfoCircle /> Created at February 15, 2024 | 8:01 PM
                  </p>
                  <p className="flex items-center gap-2">
                    {" "}
                    <HiOutlineGlobeAlt /> English
                  </p>
                </div>
              </div>
              <div className="flex w-full flex-col gap-4 border-y border-y-richblack-500 py-4 lg:hidden">
                <p className="space-x-3 pb-4 text-3xl font-semibold text-richblack-5">
                  Rs. {19999}
                </p>
                <button className="yellowButton">Enroll Now</button>
                <button className="blackButton">Request Free Demo</button>
              </div>
            </div>
            {/* Courses Card */}
            <div className="right-[2rem] top-[60px] mx-auto hidden min-h-[600px] w-1/3 max-w-[410px] translate-y-24 md:translate-y-0 lg:absolute  lg:block">
              <CourseDetailsCard />
            </div>
          </div>
        </div>
        <div className="mx-auto box-content px-4 text-start text-richblack-5 lg:w-[1260px]">
          <div className="mx-auto max-w-maxContentTab lg:mx-0 xl:max-w-[810px]">
            {/* What will you learn section */}
            <div className="my-8 border border-richblack-600 p-8">
              <p className="text-3xl font-semibold">Course Overview</p>
              <div className="mt-5">
                <ReactMarkdown>
                  {
                    "In today’s fast-evolving technological landscape, organizations face the dual challenge of managing a higher                   volume of changes while navigating increasingly complex systems. This environment amplifies the risks of outages and incidents, making it imperative for IT teams to prioritize service reliability and system resilience."
                  }
                </ReactMarkdown>
                <ReactMarkdown>
                  {
                    "The SRE Foundation Certification equips professionals with the knowledge to meet these challenges head-on by embracing automation, observability, and proactive incident management. As automation accelerates deployments and observability ensures real-time insights, Site Reliability Engineers are at the forefront of driving efficiency and reliability across IT ecosystems. "
                  }
                </ReactMarkdown>
              </div>
              <p className="text-3xl font-semibold mt-5">What you'll learn</p>
              <div className="flex flex-col gap-3 mt-5">
                <p className={`flex gap-2 items-center`}>
                  <BsFillCaretRightFill />
                  <span>
                    Understand and Implement best practices of SRE techniques.
                  </span>
                </p>
                <p className={`flex gap-2 items-center`}>
                  <BsFillCaretRightFill />
                  <span>Utilize SRE tools and techniques effectively.</span>
                </p>
                <p className={`flex gap-2 items-center`}>
                  <BsFillCaretRightFill />
                  <span>
                    Integrate SRE practices with existing organizational
                    frameworks.
                  </span>
                </p>
                <p className={`flex gap-2 items-center`}>
                  <BsFillCaretRightFill />
                  <span>
                    Enhance operational efficiency with automation and
                    observability.
                  </span>
                </p>
                <p className={`flex gap-2 items-center`}>
                  <BsFillCaretRightFill />
                  <span>
                    Decrease costs while increasing system reliability.
                  </span>
                </p>
                <p className={`flex gap-2 items-center`}>
                  <BsFillCaretRightFill />
                  <span>Build and architect complex applications.</span>
                </p>
                <p className={`flex gap-2 items-center`}>
                  <BsFillCaretRightFill />
                  <span>
                    Foster collaboration between development and operations
                    teams.
                  </span>
                </p>
              </div>
            </div>

            {/* Course Content Section */}
            <div className="max-w-[830px] ">
              <div className="flex flex-col gap-3">
                <p className="text-[28px] font-semibold">Course Curriculum</p>
                <div className="flex flex-wrap justify-between gap-2">
                  <div className="flex gap-2">
                    <span>
                      {8} {`module(s)`} &nbsp; |
                    </span>
                    <span>
                      {27} {`lecture(s)`} &nbsp; |
                    </span>
                    <span>{"1h 10m"} total length</span>
                  </div>
                  <div>
                    <button
                      className="text-yellow-25"
                      onClick={() => setIsActive([])}
                    >
                      Collapse all sections
                    </button>
                  </div>
                </div>
              </div>

              {/* Course Details Accordion */}
              <div className="py-4 ">
                <CourseAccordionBar
                  courseName={"Module 1: SRE Principles & Practices"}
                  courseList={[
                    "What is Site Reliability Engineering?",
                    "SRE & DevOps: What is the Difference?",
                    "SRE Principles & Practices",
                  ]}
                  isActive={isActive}
                  handleActive={handleActive}
                />
                <CourseAccordionBar
                  courseName={
                    "Module 2: Service Level Objectives & Error Budgets"
                  }
                  courseList={[
                    "Service Level Objectives (SLO’s)",
                    "Error Budgets",
                    "Error Budget Policies",
                  ]}
                  isActive={isActive}
                  handleActive={handleActive}
                />
                <CourseAccordionBar
                  courseName={"Module 3: Reducing Toil"}
                  courseList={[
                    "What is Toil?",
                    "Why is Toil Bad?",
                    "Doing Something About Toil",
                  ]}
                  isActive={isActive}
                  handleActive={handleActive}
                />{" "}
                <CourseAccordionBar
                  courseName={"Module 4: Monitoring & Service Level Indicators"}
                  courseList={[
                    "Service Level Indicators (SLI)",
                    "Monitoring",
                    "Observability",
                  ]}
                  isActive={isActive}
                  handleActive={handleActive}
                />
                <CourseAccordionBar
                  courseName={"Module 5: SRE Tools & Automation"}
                  courseList={[
                    "Automation Defined",
                    "Automation Focus",
                    "Hierarchy of Automation Types",
                    "Secure Automation",
                    "Automation Tools",
                  ]}
                  isActive={isActive}
                  handleActive={handleActive}
                />
                <CourseAccordionBar
                  courseName={
                    "Module 6: Anti-Fragility & Learning from Failure"
                  }
                  courseList={[
                    "Why Learn from Failure",
                    "Benefits of Anti-Fragility",
                    "Shifting the Organizational Balance",
                  ]}
                  isActive={isActive}
                  handleActive={handleActive}
                />
                <CourseAccordionBar
                  courseName={"Module 7: Organizational Impact of SRE"}
                  courseList={[
                    "Why Organizations Embrace SRE",
                    "Patterns for SRE Adoption",
                    "Sustainable Incident Response",
                    "Blameless Post-Mortems",
                    "SRE & Scale",
                  ]}
                  isActive={isActive}
                  handleActive={handleActive}
                />
                <CourseAccordionBar
                  courseName={"Module 8: SRE, Other Frameworks, Trends"}
                  courseList={["SRE & Other Frameworks", "SRE Evolution"]}
                  isActive={isActive}
                  handleActive={handleActive}
                />
              </div>


            </div>
          </div>
        </div>

        <Footer/>
      </>
    ); 
};

export default CourseDetails;
